import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedFileDownload } from '@eggplant/data-request'

interface Props {
  id: string
  onSuccess: () => void
}

const DownloadAiRunLogRequest = ({
  id,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/runlogs/${id}`

  return (
    <AuthenticatedFileDownload
      fileType='text/csv'
      filename={`run_${id}_log.csv`}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DownloadAiRunLogRequest
